import { render } from "./RegistrationEnd.vue?vue&type=template&id=bfabd698&ts=true"
import script from "./RegistrationEnd.vue?vue&type=script&lang=ts"
export * from "./RegistrationEnd.vue?vue&type=script&lang=ts"

import "./RegistrationEnd.vue?vue&type=style&index=0&id=bfabd698&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__